// HOOKS
import { useState } from "react";
// COMPONENTS
import ResetPasswordButton from "../buttons/users/resetPassword.button";

const CLASSNAMES = {
  form: "w-content border-animate rounded-2xl shadow-lg  flex flex-col justify-center items-center gap-4 p-8 bg-gray-200",
  container: "gap-2 p-2 flex flex-col w-full justify-between",
  label: "text-secondary capitalize font-ubuntuBold flex justify-start",
  input:
    "w-[400px] text-secondary shadow focus:shadow-primary px-4 py-2 font-ubuntuMedium rounded flex justify-end focus:outline-none",
};

const ResetPasswordForm = ({ classNames = CLASSNAMES }) => {
  const [email, setEmail] = useState("");

  // Set the email state
  const handleChange = (event) => {
    setEmail(event.target.value);
  };
  return (
    <form className={classNames?.form || CLASSNAMES.form}>
      <div className={classNames?.container || CLASSNAMES.container}>
        <label
          className={classNames?.label || CLASSNAMES.label}
          htmlFor="email"
        >
          Email
        </label>
        <input
          className={classNames?.input || CLASSNAMES.input}
          type="email"
          id="email"
          name="email"
          value={email}
          onChange={handleChange}
        />
      </div>
      <ResetPasswordButton email={email} />
    </form>
  );
};

export default ResetPasswordForm;
